import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "../ui/dialog";
import { Button } from "../ui/button";
import { Plus, Loader2 } from "lucide-react";
import { PilotFormFields } from "./PilotFormFields";

export function PilotCreateDialog({
  open, onOpenChange,
  formData, setFormData,
  initiatives, partners,
  newPartnerName, setNewPartnerName,
  creatingPartner, onCreatePartner,
  onSubmit, loading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="create-pilot-btn">
          <Plus className="w-4 h-4 mr-2" />Nuevo Piloto
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Crear Nuevo Piloto</DialogTitle>
          <DialogDescription>Define los parámetros del piloto según la plantilla estándar</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <PilotFormFields
            formData={formData} setFormData={setFormData}
            initiatives={initiatives} partners={partners}
            newPartnerName={newPartnerName} setNewPartnerName={setNewPartnerName}
            creatingPartner={creatingPartner} onCreatePartner={onCreatePartner}
            idPrefix="create"
          />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={loading}>
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Crear Piloto
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
